import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'platform' })
export class AttributesService {
  isSetupSubmittingAttributes: BehaviorSubject<boolean> = new BehaviorSubject(false);
  isSetupDoneSubmittingAttributes: BehaviorSubject<boolean> = new BehaviorSubject(false);
  constructor() {}
}
